<template>
  <div>
    <div v-if="!this.showCalendar">
      <Feed />
    </div>
    <div v-if="this.showCalendar">
      <Calendar />
    </div>
  </div>
</template>

<script>
import Calendar from '../components/Calendar'
import Feed from '../components/Feed'

export default {
  name: 'main-view',
  components: {
    Calendar,
    Feed
  },
  computed: {
    showCalendar () {
      return this.$store.state.showCalendar
    }
  },
  methods: {
    checkIsPhone () {
      const Mobile = window.matchMedia('only screen and (max-width: 450px)')
      return Mobile.matches
    }
  },
  mounted () {
    if (this.checkIsPhone()) {
      this.$store.dispatch('setCalendar', false)
    }
  }
}
</script>
